module.exports = __webpack_public_path__ + "img/tu6@2x.77d828cc.png";